import styled from 'styled-components';
import Slider from 'react-rangeslider';
import color from '../../../../config/colors.json';
import 'react-rangeslider/lib/index.css';

export const InvestmentQuestion = styled.span`
    color: ${color.dark};
    font-size: 15px;
    font-weight: 600;
    display: flex;
    justify-content: flex-start;
	font-family: Poppins, Heltica, Arial, sans-serif;
    margin-bottom: 30px;
`;

export const InvestmentSlider = styled(Slider)`
    padding: 3px !important;
    box-shadow: none !important;
    background: ${color.lightGrey11} !important;

    .rangeslider__fill {
        background-color: ${color.darkGrey2} !important;
        height: 6px !important;
        box-shadow: none !important;
    }
    
    .rangeslider__handle {
        outline: 0;
        background: ${color.lightRed} !important;
        border: 1px solid ${color.lightRed} !important;
        box-shadow: none !important;

        :after {
            background-color: #fff !important;
            box-shadow: none !important;
        }
    }
`;

export const InvestmentValue = styled.div`
    font-size: 23px;
    font-weight: 600;
    color: ${color.lightRed};
    display: flex;
    justify-content: flex-start;
	font-family: Poppins, Heltica, Arial, sans-serif;
    margin-bottom: 18.11px;
`;
